import Sessions from '@/components/session/sessions-ui';

const Session = () => {
    return <Sessions />;
};

export default Session;
